import { TerritorySwitch } from "@core/pegasus-one-territory/src/script.js";
import { IpDetectionBar } from "@core/pegasus-one-territory/src/script.js";
import Alpine from "alpinejs";

// Override the original classes
export class MyTerritorySwitch extends TerritorySwitch {
    formatSelector(selector) {
        // Add your custom functionality here to format the selector. Such as:
        pegasus.selectField(selector, {
            openOnHover: false,
            itemsToShow: 5,
            firstItemDisabled: true,
            classNames: {
                outerWrapper: "",
                selector:
                    "Form__Selector bg-secondary-surface -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                selectorOpen: "-open",
                selectionList:
                    "Form__Selector-list w-full bg-secondary-surface rounded-b-md -open",
                listItem:
                    "select-none relative transition duration-300 py-2 px-2",
                listItemFocus: "bg-secondary-pink",
            },
        });
    }
    // Optionally you can override the other methods as well
}
// At the end, replace the original class with the new one
Alpine.data("territorySwitch", () => new MyTerritorySwitch());

// You can do the same thing with the IpDetectionBar
export class MyIpDetectionBar extends IpDetectionBar {
    formatSelector(selector) {
        pegasus.selectField(selector, {
            openOnHover: false,
            itemsToShow: 5,
            firstItemDisabled: true,
            classNames: {
                outerWrapper: "",
                selector:
                    "Form__Selector -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                selectorOpen: "-open",
                selectionList:
                    "Form__Selector-list w-full bg-white rounded-b-md -open",
                listItem:
                    "select-none relative transition duration-300 py-4 px-6",
                listItemFocus: "bg-secondary-surface",
            },
        });
    }
}
Alpine.data("ipDetectionBar", () => new MyIpDetectionBar());
